import { steps } from './landingContent';
import { assetUrl } from './landingHelpers';

const browserDots = ['#FF2D46', '#FF9500', '#63DE77'];
const stepColors = ['var(--bl-blue)', 'var(--bl-violet)', 'var(--bl-green)', '#ff72f8'];

const HowItWorks = () => (
  <section className="bl-how" id="howitworks">
    <div className="bl-how__inner">
      <div className="bl-how__grid">
        <div>
          <div className="bl-how__eyebrow">How it works</div>
          <h2 className="bl-how__title">
            From data to insight<br />
            in four steps.
          </h2>
          <p className="bl-how__sub">
            BodyLytiX connects your devices, learns your patterns, and gives you answers that are actually about you.
          </p>

          <div className="bl-how__steps">
            {steps.map((step, index) => (
              <article className="bl-how-step" key={step.number}>
                <span style={{ color: stepColors[index] }}>{step.number}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="bl-performance-preview" aria-label="BodyLytiX Daily Performance screenshot">
          <div className="bl-performance-preview__glow" />
          <div className="bl-performance-badge">
            <span>Performance</span>
            <strong>61</strong>
            <small>Strong Day ↑</small>
          </div>
          <div className="bl-performance-frame">
            <div className="bl-performance-bar">
              {browserDots.map((color) => (
                <span style={{ background: color }} key={color} />
              ))}
              <p>app.bodylytix.ai - Daily Performance</p>
            </div>
            <div className="bl-performance-image-wrap">
              <img src={assetUrl('/assets/img/landing/daily-performance.png')} alt="BodyLytiX Daily Performance" />
              <div className="bl-performance-fade" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
